export default __webpack_public_path__ + "static/media/AstronomyMars_09.0ad48acd.png";